import { Link, useNavigate } from 'react-router'
import { Box, Button, IconLogout, Stack } from '@n26/nxd'
import { useTranslation } from 'react-i18next'
import { Logo } from '@/shared/components/Logo'
import { useAuth } from '@/features/auth/hooks/useAuth'
import { SLIM_ROUTES } from '@/shared/routes'
import styles from './Header.module.css'

export const Header = () => {
  const { t } = useTranslation()
  const { logout } = useAuth()
  const navigate = useNavigate()

  const handleLogout = async () => {
    await logout()
    navigate(SLIM_ROUTES.LOGIN, { replace: true })
  }

  return (
    <Box
      as='header'
      paddingLeft={{ mobile: '16', desktop: '32' }}
      paddingRight={{ mobile: '0', desktop: '16' }}
      paddingY='16'
    >
      <Stack direction='horizontal' align='center' justify='space-between'>
        <Link to={SLIM_ROUTES.HOME} className={styles.logoLink}>
          <Logo className={styles.logo} />
        </Link>

        <Button
          type='button'
          variant='tertiary'
          size='small'
          color='neutral'
          leadingIcon={<IconLogout />}
          onClick={handleLogout}
        >
          {t('auth.logout')}
        </Button>
      </Stack>
    </Box>
  )
}
